import { FORMAT_LABELS, FormatSchema, type Format } from '@ugin/shared';

import { useSettings } from '@/store/settings';
import { ArenaStatusWidget } from '@/widgets/arena-status';
import { DeckListWidget } from '@/widgets/deck-list';
import { LogStreamWidget } from '@/widgets/log-stream';
import { MetaShareWidget } from '@/widgets/meta-share';
import { PersonalMetaWidget } from '@/widgets/personal-meta';
import { RecentMatchesWidget } from '@/widgets/recent-matches';
import { RecordWidget } from '@/widgets/record';

/** The formats Rowan plays. The rest stay reachable from the Meta page. */
const PRIMARY_FORMATS: Format[] = ['historic', 'standard'];

export function Dashboard() {
  const format = useSettings((s) => s.defaultFormat);
  const setFormat = useSettings((s) => s.setDefaultFormat);

  return (
    <div className="space-y-6">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div className="space-y-1">
          <h1 className="font-display text-4xl tracking-wide text-ugin-text">
            <span className="bg-gradient-to-br from-ugin-text via-ugin-accent to-ugin-mystic bg-clip-text text-transparent">
              Welcome back
            </span>
          </h1>
          <p className="text-sm text-ugin-text-muted">
            What Ugin has seen of your games, and what you have been running into.
          </p>
        </div>

        <label className="flex flex-col gap-1 text-xs text-ugin-text-muted">
          Format
          <select
            value={format}
            onChange={(e) => { setFormat(e.target.value as Format); }}
            className="min-w-40 rounded-lg border border-ugin-border bg-ugin-surface px-3 py-2 text-sm text-ugin-text outline-none focus-visible:ring-2 focus-visible:ring-ugin-accent"
          >
            {[...PRIMARY_FORMATS, ...FormatSchema.options.filter((f) => !PRIMARY_FORMATS.includes(f))].map(
              (f) => (
                <option key={f} value={f}>
                  {FORMAT_LABELS[f]}
                </option>
              ),
            )}
          </select>
        </label>
      </header>

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-12">
        <div className="space-y-6 xl:col-span-4">
          <ArenaStatusWidget />
          <RecordWidget format={format} />
        </div>
        <div className="space-y-6 xl:col-span-8">
          <RecentMatchesWidget format={format} limit={8} />
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <PersonalMetaWidget format={format} />
            <div className="space-y-6">
              <MetaShareWidget format={format} compact />
              <DeckListWidget compact />
            </div>
          </div>
          <LogStreamWidget limit={10} />
        </div>
      </div>
    </div>
  );
}
